import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { InstantSearch, SearchBox, Configure, InfiniteHits, Highlight } from 'react-instantsearch/dom';
import { connectStateResults } from 'react-instantsearch/connectors';
import { Form, Text } from 'react-form';
import swal from 'sweetalert2';
import { envoyerQuestion, journaliserErreur } from '../../App_Code/API';
import { AlgoliaAppId, AlgoliaApiKey } from '../../App_Data/ClesAPI';
import Card from '../Card';
import Chargement from '../Chargement';

const SearchBoxFrancais = {
    submitTitle: 'Soumettre la recherche.',
    resetTitle: 'Effacer la recherche.',
    placeholder: 'Saisissez votre question ici...',
};

const InfiniteHitsFrancais = {
    loadMore: 'Voir plus de questions...',
};

function EnvoiQuestion(question, submittedValues, history) {
    const { precision } = submittedValues;

    envoyerQuestion(question, precision).then((response) => {
        if (response && response.status === 200 && response.data > 0) {
            swal('Envoyé', 'Nos services vous apporteront une réponse dans les plus brefs délais.', 'success');
            history.push('/');
        } else {
            swal('Erreur', 'La question n&apos;a pas été envoyé.', 'error');
        }
    });
}

const AlerteErreur = ({ erreur }) => {
    if (erreur) {
        const chemin = window.location.pathname.split('/');
        const EE = {
            Page: chemin[chemin.length - 1],
            Methode: 'WrapperChargement',
            Message: 'Impossible de charger la FAQ',
            Source: window.location.href,
        };
        journaliserErreur(EE);
    }

    return (
        <div className="jumbotron alert-danger text-center">
            <h1 className="display-4">Une erreur s&apos;est produite.</h1>
        </div>
    );
};

const WrapperChargement = connectStateResults(({ searching, error, children }) => (
    <React.Fragment>
        <div hidden={!searching}>
            <Chargement />
        </div>
        <div hidden={!error}>
            <AlerteErreur erreur={error} />
        </div>
        <div hidden={searching || error}>{children}</div>
    </React.Fragment>
));

const WrapperResultats = connectStateResults(({ searchResults, children }) =>
    (searchResults && searchResults.nbHits > 0 ? children : <SaisieQuestion {...searchResults} />));

const Question = ({ hit }) => (
    <div className="card">
        <div className="card-header p-0" id={`heading${hit.objectID}`}>
            <h5 className="m-0">
                <button
                    className="btn btn-lg btn-block btn-light hit-name font-weight-bold"
                    data-toggle="collapse"
                    data-target={`#collapse${hit.objectID}`}
                    aria-expanded="true"
                    aria-controls={`collapse${hit.objectID}`}
                >
                    <Highlight attribute="question" hit={hit} />
                </button>
            </h5>
        </div>
        <div
            id={`collapse${hit.objectID}`}
            className="collapse"
            aria-labelledby={`heading${hit.objectID}`}
            data-parent="#accordion"
        >
            <div className="card-body">
                <div dangerouslySetInnerHTML={{ __html: hit.reponse }} />
                {hit.docNom && (
                    <Link
                        to={{ pathname: '/MesInformations/Document', state: { URI: hit.docUrl } }}
                        className="btn btn-primary"
                    >
                        {hit.docNom}
                    </Link>
                )}
            </div>
        </div>
    </div>
);

const SaisieQuestion = withRouter(({ query, history }) => (
    <Card Titre="Aucun résultat">
        <div className="alert alert-primary" role="alert">
            <i className="fas fa-info-circle" /> Il semblerait que vous n&apos;ayez pas trouvé de réponse à votre
            question.<br />
            Vous pouvez soumettre une question en remplissant le formulaire ci-dessous.<br />
            <b>Veuillez utiliser ce formulaire uniquement pour contacter le webmaster de ce site.</b>
            <br />
            Pour toutes questions destinées à votre syndic, veuillez utiliser{' '}
            <Link to="/MaMessagerie/Ecrire">ce formulaire</Link>.
        </div>
        <Form onSubmit={submittedValues => EnvoiQuestion(query, submittedValues, history)}>
            {formApi => (
                <form onSubmit={formApi.submitForm}>
                    <div className="form-group required">
                        <Text
                            field="precision"
                            id="precision"
                            placeholder="Optionnel : précisez votre question ici"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="text-center">
                        <button type="submit" className="btn btn-lg btn-success">
                            Poser la question
                        </button>
                    </div>
                </form>
            )}
        </Form>
    </Card>
));

const PageAide = () => (
    <InstantSearch appId={AlgoliaAppId} apiKey={AlgoliaApiKey} indexName="FAQ_extranet">
        <div className="container">
            <h3 className="mt-3 text-center">
                <span className="text-primary">
                    <i className="far fa-question-circle" />
                </span>{' '}
                Foire aux questions
            </h3>
            <SearchBox className="mt-3 mb-3" translations={SearchBoxFrancais} />
            <Configure hitsPerPage={5} />
            <WrapperChargement>
                <WrapperResultats>
                    <div id="accordion">
                        <InfiniteHits hitComponent={hit => <Question {...hit} />} translations={InfiniteHitsFrancais} />
                    </div>
                </WrapperResultats>
            </WrapperChargement>
        </div>
    </InstantSearch>
);
PageAide.displayName = 'PageAide';

export default PageAide;



// WEBPACK FOOTER //
// ./src/components/App/PageAide.js